// Bulletin → feed integration: the discovery card for a published
// Bulletin post. The Bulletin page (public-site /bulletin/{slug}) stays
// canonical — this card carries the title + first-paragraph excerpt and
// an honest link-out CTA, mirroring CuratedNewsCard's shape (no inline
// article body, card surface not clickable).

import { ParchmentPost } from "@greenhold/components";

import { parchmentCtaClass, relativeTime, wearSeed } from "./feedCardShared";
import type { FeedCard } from "./useFeed";

export function BulletinCard({ card }: { card: FeedCard }) {
  return (
    <ParchmentPost
      author="Greenhold Bulletin"
      provenance="editorial"
      time={relativeTime(card.published_at)}
      title={card.title}
      pinned={card.is_pinned}
      seed={wearSeed(card.id)}
    >
      {card.body ? (
        <p className="m-0 whitespace-pre-line">{card.body}</p>
      ) : null}
      {card.external_url ? (
        <p className="m-0 mt-3">
          <a
            href={card.external_url}
            target="_blank"
            rel="noopener noreferrer"
            className={parchmentCtaClass}
            data-testid="card-link-out"
          >
            Read the full post →
          </a>
        </p>
      ) : null}
    </ParchmentPost>
  );
}
